import React from 'react';
import { POWERBI_IDS } from '../../utils/Constant';
import EmbededPowerBi from '../../components/EmbededPowerBI';

const DashboardPage: React.FunctionComponent = () => {
  return (
    <div className="dashboard-parent">
      <div className="dashboard">
        <EmbededPowerBi
          groupId={POWERBI_IDS.groupId}
          reportId={POWERBI_IDS.dashboardId}
        />
      </div>
    </div>
  );
};

export default DashboardPage;
